import { useEffect } from "react"
import { apiClient } from "../../services/Api";

const Logout = () => {

  useEffect(() => {
    (async () => {
      try {
        const { data } = await
          apiClient.post('/logout/',
            { refresh_token: localStorage.getItem('refresh_token') });

        localStorage.clear();
        apiClient.defaults.headers.common['Authorization'] = null;
        window.location.href = '/login';
      } catch (e) {
        console.log('logout not working', e)
      }
    })();
  }, []);

  return (
    <div></div>
  )
}

export default Logout;